module.exports = __webpack_public_path__ + "img/Like.0387777a.svg";